/**
 * Is the Pendo object assigned to the global window object?
 */
export const loaded = (): boolean => {
    return Boolean(window && window.pendo);
};

/**
 * Initialise Pendo with an authed users AP Reference. Assumes
 * Pendo object is assigned
 *
 * @param ap_ref
 */
export const init = (ap_ref: string) => {
    window.pendo.initialize({
        visitor: {
            id: ap_ref,
        },
        account: {
            id: 'ACCOUNT-UNIQUE-ID',
        },
    });
};

/**
 * Clear current pendo session. Assumes Pendo object is assigned
 */
export const clear = () => {
    if (!window.pendo?.clearSession) {
        console.warn('cannot clear session - pendo uninitialized');
        return;
    }
    window.pendo.clearSession();
};
